module.exports = __webpack_public_path__ + "assets/img/border-active-81b78cf7.png";